import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const BlueBtn = styled.button`
  padding: 0 20px;
  margin: 15px;
  background-color: var(--lp-colors-medium-blue-800);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-800);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 40px;

  &:disabled {
    opacity: 0.5;
  }
  &:first-of-type {
    margin-left: 0;
  }
`;

export const FilterBtn = styled.button`
  padding: 5px 10px;
  border: none;
  background-color: white;
  cursor: pointer;
  margin-top: 40px;
  margin-bottom: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 300;
  text-decoration: none;
  color: var(--lp-colors-medium-blue-600);

  svg {
    vertical-align: top;
  }
`;

export const SpinnerWrapper = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormRow = styled.div`
  margin-bottom: 20px;
`;

export const FormControl = styled.select`
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
`;

export const ActivateBtn = styled.button`
  width: 80px;
  height: 24px;
  background-color: var(--lp-colors-medium-blue-600);
  border: 1px solid var(--lp-colors-medium-blue-600);
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  padding: 4px 10px 4px 10px;
  margin-left: 20px;
  font-size: 13px;
  &:focus {
    outline: none;
  }
`;

export const TextInput = styled(Input)`
  padding-left: 10px;
`;

export const FormField = styled.div`
  position: relative;
`;

export const FormCurrencyField = styled.div`
  position: relative;
  &:before {
    content: '$';
    left: 1px;
    top: 1px;
    border: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    position: absolute;
    line-height: 38px;
    background: #f8f9fb;
    width: 35px;
    text-align: center;
  }
`;

export const Button = styled.button`
  position: relative;
`;

export const PaginationRow = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
`;

interface VInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
}
export const VInput = styled(Input)<VInputProps>`
  width: 500px;
  border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #dce3eb')};
  &:focus {
    border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #505bcc')};
  }
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
  color: #6c7488;
`;

export const Flex = styled.div`
  display: flex;
`;

type BtnProps = {
  width?: string;
  hasMarginLeft?: boolean;
};

export const Btn = styled.button<BtnProps>`
  background-color: var(--lp-colors-medium-blue-600);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-600);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: ${({ width }) => width ?? '150px'};
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  padding: 12px 0 9px;
  cursor: pointer;
  outline: none;
  margin-left: ${({ hasMarginLeft }) => (hasMarginLeft ? '15px' : '0')};
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const BtnSpinner = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 6px;
  padding-top: 1px;
`;

export const InvalidText = styled.div`
  font-size: 14px;
  color: red;
  position: absolute;
  right: 159px;
`;
